import RedeemActivityPage from "./RedeemActivityPage";

export default RedeemActivityPage;